import { IsInt, IsOptional, IsString, Max, MaxLength, Min } from 'class-validator';
import {
  DEADLINE_ASSIGNEE_ID_MAX_LENGTH,
  DEADLINE_TITLE_MAX_LENGTH,
  MAX_RENEWAL_VALIDITY_MONTHS,
} from './deadline.constants';
import { DeadlineWarningDaysDto } from './deadline-warning-days.dto';
import { IsIsoDay } from './is-iso-day.decorator';

export class UpdateDeadlineDto extends DeadlineWarningDaysDto {
  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_TITLE_MAX_LENGTH)
  title?: string;

  @IsOptional()
  @IsString()
  documentTypeId?: string;

  /** `null` = rimuovi la scadenza, `undefined` = invariata. */
  @IsOptional()
  @IsIsoDay()
  dueAt?: string | null;

  /** `null` = togli la persona, `undefined` = invariata. */
  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_ASSIGNEE_ID_MAX_LENGTH)
  assigneeUserId?: string | null;

  /** `null` = diventa unica, numero = si rinnova ogni N mesi, `undefined` = invariata. */
  @IsOptional()
  @IsInt()
  @Min(1)
  @Max(MAX_RENEWAL_VALIDITY_MONTHS)
  validityMonths?: number | null;
}
